import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { Box } from 'rebass/styled-components'
import Meta from '../components/general/Meta'
import Header from '../modules/Header'
import Footer from '../modules/Footer'
import Modal from '../modules/Modal'
import Dialogs from '../modules/Dialogs'
import { verifyAuth } from '../models/Users'

const DefaultLayout = ({ dispatch, children, location, globals }) => {
    useEffect(() => {
        verifyAuth(dispatch)
    }, [])

    return (
        <Box>
            {
                globals && globals.environment !== 'production' ?
                    <Box py='4px' px='5px' sx={{
                        backgroundColor: globals.primaryColor,
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        zIndex: 99999,
                    }}>
                        <Box sx={{
                            color: '#fff',
                            fontWeight: 'bold',
                            fontSize: '10px',
                        }}>{globals.environment} - {globals.version}</Box>
                    </Box> : null
            }
            <Meta location={location} />
            <Header />
            {children}
            <Footer />
            <Modal />
            <Dialogs />
        </Box>
    )
}

function mapStateToProps(state) {
    return {
        globals: state.Globals,
    }
}
export default connect(mapStateToProps)(DefaultLayout)
